module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_0.0214e2f8.png";